import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

const Parallax = () => {
  gsap.registerPlugin(ScrollTrigger);

  const container = document.querySelector('.intro');
  const shampoo = document.querySelector('.intro__exp--img--item--01');
  const treatment = document.querySelector('.intro__exp--img--item--02');
  const mask = document.querySelector('.intro__exp--img--item--03');
  const oil = document.querySelector('.intro__exp--img--item--04');

  gsap.to(shampoo, {
    y: -150,
    scrollTrigger: {
      trigger: container,
      scrub: 0.8,
    },
  });
  gsap.to(treatment, {
    y: -220,
    scrollTrigger: {
      trigger: container,
      scrub: true,
    },
  });
  gsap.to(mask, {
    y: -200,
    scrollTrigger: {
      trigger: container,
      scrub: 0.4,
    },
  });
  gsap.to(oil, {
    y: -150,
    scrollTrigger: {
      trigger: container,
      scrub: 1,
    },
  });
};

export default Parallax;
